import React from 'react';
import PropTypes from 'prop-types';
import pick from 'lodash/pick';
import Description from '../Description';
import { Row } from 'wonderbly-components/lib/Grid';
import CountryOption from './CountryOption';
import './ChooseYourCountry.scss';

const ChooseYourCountry = props => (
  <section className="choose-your-country">
    <div className="container-guttered">
      <Row>
        <div className="col-4-5">
          <Description {...pick(props, 'primary')} className="aligned-center" />
          <div className="country-list">
            {props.countries.map(country => (
              <CountryOption
                key={`${country.iso}-${country.locale}`}
                image={country.flag}
                name={country.name}
                iso={country.iso}
                locale={country.localeCode}
                isActive={`${country.iso}-${country.locale}` === `${props.country.iso}--${props.country.locale}`}
              />
            ))}
          </div>
        </div>
      </Row>
    </div>
  </section>
);

ChooseYourCountry.propTypes = {
  primary: PropTypes.shape({
    content: PropTypes.array.isRequired
  }).isRequired,
  countries: PropTypes.arrayOf(
    PropTypes.shape({
      flag: PropTypes.object.isRequired,
      name: PropTypes.string.isRequired,
      prefix: PropTypes.string.isRequired,
      iso: PropTypes.string.isRequired,
      locale: PropTypes.string.isRequired
    })
  ).isRequired,
  country: PropTypes.shape({
    name: PropTypes.string.isRequired,
    prefix: PropTypes.string.isRequired,
    iso: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired
  })
};

export default ChooseYourCountry;



// WEBPACK FOOTER //
// ./src/client/js/view/components/ChooseYourCountry/ChooseYourCountry.js